export const yalo_images = {
  logo_yalo_beneficios: require('./logo_yalo_beneficios.png'),
  logo_yalo: require('./yalo.png'),
  yalo_flor: require('./Yalo_flor_64px.png'),
  bar_code: require('./bar_code.png'),
  xml_file: require('./xml_file.png'),
  yalo_flor_grande: require('./Yalo_Flor_512px.png')
};
